import type { AxiosInstance } from 'axios'

export default (axiosClient: AxiosInstance) => {
  axiosClient.interceptors.request.use(async config => {
    // * to prevent modal stucking on screen
    return config
  })
}
